import {classNames} from '@cohort/shared-frontend/utils/classNames';
import useThemeContext from '@cohort/wallet/hooks/useThemeContext';
import React from 'react';

interface SubtitleProps {
  content: string | JSX.Element;
  icon?: JSX.Element;
  testId?: string;
  classes?: string;
}

export const Subtitle: React.FC<SubtitleProps> = ({content, icon, testId, classes}) => {
  const {hasDarkBg} = useThemeContext();

  return (
    <div
      data-testid={testId}
      className={classNames(
        'w-full break-words text-lg leading-tight',
        hasDarkBg ? 'text-white/50' : 'text-black/50',
        classes
      )}
      dangerouslySetInnerHTML={{__html: content as string}}
    >
      {icon}
    </div>
  );
};
Subtitle.displayName = 'Subtitle';
